var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "start"
  }, [_c('send-sample-dialog', {
    attrs: {
      "samples": _vm.EXAMPLES
    }
  }), _c('start-header', {
    attrs: {
      "media": {
        id: 'b1a94da6-08ef-4a9e-85a0-4d0642348508',
        alt: 'Group e-cards',
        video: true
      },
      "bg": {
        src: 'https://cdn.ellacard.com/media/007ea327-b4b4-42cd-a372-870177de6d9e/lg.mp4',
        color: '#9A9C98'
      },
      "to": {
        name: 'catalog',
        hash: '#search'
      }
    },
    on: {
      "click-laptop": function ($event) {
        _vm.global.lastSelectedType = 'GROUP';
      }
    },
    scopedSlots: _vm._u([{
      key: "h1",
      fn: function () {
        return [_vm._v("Group greeting cards from Ellacard")];
      },
      proxy: true
    }, {
      key: "h2",
      fn: function () {
        return [_vm._v("The best way to create and send personalized, memorable, group greeting cards.")];
      },
      proxy: true
    }])
  }), _c('start-layer', {
    attrs: {
      "clip-waves-class": "light-gradient",
      "offset": .75
    }
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog',
        hash: '#search'
      }
    },
    on: {
      "!click": function ($event) {
        _vm.global.lastSelectedType = 'GROUP';
      }
    }
  }, [_vm._v(" Start a group card "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1), _c('div', {
    staticClass: "grid-alternate"
  }, [_vm._l(_vm.EXAMPLES, function (ex) {
    return [_c('start-preview', {
      attrs: {
        "to": {
          hash: ex.hash
        },
        "pages": ex.pages,
        "alt": ex.alt
      }
    }), _c('div', [_c('h4', {
      staticClass: "mb-3"
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(ex.icon)
      }
    }), _vm._v(" " + _vm._s(ex.title))], 1), _c('div', {
      staticClass: "mb-6",
      domProps: {
        "innerHTML": _vm._s(ex.body)
      }
    }), _c('v-btn', {
      staticClass: "btn-pop",
      attrs: {
        "rounded": "",
        "dark": "",
        "color": "ec-blue",
        "title": ex.title + ' demo',
        "to": {
          hash: ex.hash
        }
      }
    }, [_vm._v(" Try demo… ")])], 1)];
  })], 2), _c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog',
        hash: '#search'
      }
    },
    on: {
      "!click": function ($event) {
        _vm.global.lastSelectedType = 'GROUP';
      }
    }
  }, [_vm._v(" Start a group card "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)]), _c('start-layer', {
    attrs: {
      "clip-waves-class": "gold-gradient",
      "offset": .9
    }
  }, [_c('h2', [_vm._v("How it works")]), _c('div', {
    staticClass: "grid-alternate"
  }, [_c('web-media', {
    staticClass: "d-block hover-pop rounded-xl white",
    attrs: {
      "aspect-ratio": "4 / 3",
      "id": "4a0deb61-daa4-4d54-b79a-eebc1b966ed0",
      "alt": "Sample card designs splashing down on a wooden table",
      "is-video": "",
      "to": {
        name: 'catalog',
        hash: '#search'
      }
    },
    nativeOn: {
      "click": function ($event) {
        _vm.global.lastSelectedType = 'GROUP';
      }
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Choose or create the perfect design")]), _c('div', {
    staticClass: "mb-6"
  }, [_vm._v("Start with one of our "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog',
        hash: '#search'
      }
    },
    on: {
      "!click": function ($event) {
        _vm.global.lastSelectedType = 'GROUP';
      }
    }
  }, [_vm._v("thousands of designs")]), _vm._v(" for "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog-categories',
        hash: '#search'
      }
    },
    on: {
      "!click": function ($event) {
        _vm.global.lastSelectedType = 'GROUP';
      }
    }
  }, [_vm._v("every occasion")]), _vm._v(", or use our editing tools to "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog',
        query: {
          q: '#design-your-own'
        },
        hash: '#search'
      }
    },
    on: {
      "!click": function ($event) {
        _vm.global.lastSelectedType = 'GROUP';
      }
    }
  }, [_vm._v("upload / create your own")]), _vm._v(".")], 1)]), _c('web-media', {
    staticClass: "hover-pop rounded-xl white",
    attrs: {
      "aspect-ratio": "4 / 3",
      "id": "607e1c42-594a-42d8-88dc-3b1c47c92641",
      "alt": "Using the Ellacard editor to personalize a card",
      "is-video": ""
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Personalize your card")]), _c('div', [_vm._v(" Add messages, pictures, videos, colors, backgrounds, music, confetti, and more. Ellacard's collaborative editing tools are unmatched and work perfectly on phones and computers. ")])]), _c('web-media', {
    staticClass: "d-block hover-pop rounded-xl white",
    attrs: {
      "aspect-ratio": "4 / 3",
      "id": "28aa786a-d55c-49d6-a894-0ac9ac9692f9",
      "alt": "Adding value to a group gift card",
      "is-video": "",
      "to": {
        name: 'catalog-gift-cards',
        hash: '#search'
      }
    },
    nativeOn: {
      "click": function ($event) {
        _vm.global.lastSelectedType = 'GROUP';
      }
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Add a group gift card")]), _c('div', [_vm._v(" Optionally add a group gift card from "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog-gift-cards'
      }
    },
    on: {
      "!click": function ($event) {
        _vm.global.lastSelectedType = 'GROUP';
      }
    }
  }, [_vm._v("thousands of international merchants")]), _vm._v(". Anyone can add value to it, and you can even choose to hide the total value from contributors. ")], 1)]), _c('div', {
    staticClass: "relative hover-pop-group",
    staticStyle: {
      "aspect-ratio": "8 / 7"
    }
  }, [_c('div', {
    staticClass: "absolute rounded grey lighten-5 rn2 pa-3 overflow-hidden",
    staticStyle: {
      "width": "60%",
      "left": "0",
      "top": "0",
      "max-height": "100%"
    }
  }, [_c('web-media', {
    staticClass: "elevation-3",
    attrs: {
      "aspect-ratio": "166 / 362",
      "id": "132180a1-18b4-4720-bae6-2714d9a47d43",
      "alt": "Example email invitation to sign a group card on Ellacard",
      "min": "lg"
    }
  })], 1), _c('web-media', {
    staticClass: "absolute r3 has-alpha",
    staticStyle: {
      "width": "50%",
      "top": "5%",
      "right": "1%"
    },
    attrs: {
      "aspect-ratio": "240 / 435",
      "id": "672bd30f-187a-4d8f-ba83-122b07bd4ba4",
      "alt": "Example text message invitation to sign a group card on Ellacard",
      "min": "lg"
    }
  })], 1), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Invite contributors to sign")]), _c('div', [_vm._v(" Share / post a link to sign the card, or use Ellacard to invite contributors via email / text. You can make personal messages from others private. ")])]), _c('div', {
    staticClass: "relative hover-pop-group",
    staticStyle: {
      "aspect-ratio": "4 / 3"
    }
  }, [_c('outline-laptop', {
    staticClass: "absolute has-alpha",
    staticStyle: {
      "width": "110%",
      "left": "-4%"
    }
  }, [_c('web-media', {
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "6477f405-c06e-4064-a5a3-a45ec556de3b",
      "alt": "Opening an Ellacard (landscape)",
      "is-video": ""
    }
  })], 1), _c('outline-phone', {
    staticClass: "absolute has-alpha rn5",
    staticStyle: {
      "top": "10%",
      "width": "32%",
      "left": "0"
    },
    attrs: {
      "vertical": ""
    }
  }, [_c('web-media', {
    attrs: {
      "aspect-ratio": "9 / 16",
      "id": "0938a4be-cc9d-4fd6-af8f-98c30f68ca30",
      "alt": "Opening an Ellacard (portrait)",
      "is-video": ""
    }
  })], 1), _c('web-media', {
    staticClass: "absolute rounded r3 white",
    staticStyle: {
      "width": "50%",
      "bottom": "-3%",
      "right": "0"
    },
    attrs: {
      "aspect-ratio": "640 / 504",
      "id": "5a0b7247-74cb-40de-8e47-1621af63c010",
      "alt": "Group card status page after sending"
    }
  })], 1), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Choose how / when to send your card")]), _c('div', [_vm._v(" Set a send date, and Ellacard will automatically send your card via email / text. Track delivery status and let your recipient reply with a message. ")])])], 1), _c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog',
        hash: '#search'
      }
    },
    on: {
      "!click": function ($event) {
        _vm.global.lastSelectedType = 'GROUP';
      }
    }
  }, [_vm._v(" Start a group card "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)]), _c('start-layer', {
    attrs: {
      "clip-waves-class": "dark-gradient",
      "offset": .6
    }
  }, [_c('h2', [_vm._v("Business tools")]), _c('div', {
    staticClass: "grid-alternate"
  }, [_c('web-media', {
    staticClass: "d-block hover-pop rounded white",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "4c484036-9f33-4725-b6c1-0509f97a02ef",
      "alt": "Automation",
      "is-video": "",
      "to": {
        name: 'start-automation'
      }
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Automation")]), _c('div', {
    staticClass: "mb-6"
  }, [_vm._v("Ellacard will automatically schedule group cards in advance, including inviting contributors to sign. Perfect for things like employee birthdays and work anniversaries.")]), _c('div', {
    staticClass: "ma-n2"
  }, [_c('v-btn', {
    staticClass: "ma-2 btn-pop",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'batch-order'
      }
    }
  }, [_vm._v(" Create an automation "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-btn', {
    staticClass: "ma-2 btn-pop",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "title": "More about automation tools",
      "to": {
        name: 'start-automation'
      }
    }
  }, [_vm._v(" Learn more "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)]), _c('web-media', {
    staticClass: "d-block hover-pop rounded white",
    attrs: {
      "aspect-ratio": "1",
      "id": "5a52ae1d-b5e9-4b51-856b-a4c93a527c1c",
      "alt": "Business tools / user activity",
      "to": {
        name: 'start-recognition'
      }
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Shared managed accounts")]), _c('div', {
    staticClass: "mb-6"
  }, [_vm._v(" Give your whole team access so anyone can send kudos / thanks for a job well done using your organization's credits. Collect detailed metrics on how your team is using Ellacard. ")]), _c('div', {
    staticClass: "ma-n2"
  }, [_c('v-btn', {
    staticClass: "ma-2 btn-pop",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'account-org'
      }
    }
  }, [_vm._v(" Create an organization "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-btn', {
    staticClass: "ma-2 btn-pop",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "title": "More about employee recognition / rewards",
      "to": {
        name: 'start-recognition'
      }
    }
  }, [_vm._v(" Learn more "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)]), _c('web-media', {
    staticClass: "d-block hover-pop rounded white",
    attrs: {
      "aspect-ratio": "432 / 324",
      "id": "7ac8562f-ba12-478b-8f19-95830b40666c",
      "alt": "Bulk email campaign metrics",
      "to": {
        name: 'start-bulk-email'
      }
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Bulk email")]), _c('div', {
    staticClass: "mb-6"
  }, [_vm._v(" Use Ellacard to send your group card in a bulk email campaign to as many recipients as you want. Automatically handle unsubscribes and collect detailed metrics. Perfect to send out a corporate holiday card. ")]), _c('div', {
    staticClass: "ma-n2"
  }, [_c('v-btn', {
    staticClass: "ma-2 btn-pop",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'bulk-email'
      }
    }
  }, [_vm._v(" Create an email campaign "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-btn', {
    staticClass: "ma-2 btn-pop",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "title": "More about bulk email",
      "to": {
        name: 'start-bulk-email'
      }
    }
  }, [_vm._v(" Learn more "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)]), _c('web-media', {
    staticClass: "d-block hover-pop rounded white",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "74458356-0685-440d-8a14-bb7cd66aa31e",
      "alt": "Custom branding example",
      "is-video": "",
      "to": {
        name: 'start-embedding-api'
      }
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Custom branding")]), _c('div', {
    staticClass: "mb-6"
  }, [_vm._v(" Add your own logo and colors. Send cards from your own email address. Host Ellacard on your own site with our "), _c('router-link', {
    attrs: {
      "to": {
        name: 'start-embedding-api'
      }
    }
  }, [_vm._v("embedding API")]), _vm._v(" for a fully white-labelled experience. ")], 1), _c('div', {
    staticClass: "ma-n2"
  }, [_c('v-btn', {
    staticClass: "ma-2 btn-pop",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'account-org-branding'
      }
    }
  }, [_vm._v(" Set up custom branding "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-btn', {
    staticClass: "ma-2 btn-pop",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "title": "More about embedding",
      "to": {
        name: 'start-embedding-api'
      }
    }
  }, [_vm._v(" Learn more "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)])], 1)]), _c('start-reviews', {
    attrs: {
      "tag": "GR"
    }
  }), _c('start-footer')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }